import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-3, arrow"><path d="M4.28743 2.68029C3.28376 2.30578 2.30481 3.28474 2.67931 4.2884L8.27448 19.2835C8.5926 20.136 9.68603 20.3738 10.3295 19.7304L12.2491 17.8107L16.1152 21.6769C16.6034 22.165 17.3948 22.165 17.883 21.6769L21.6759 17.884C22.164 17.3958 22.164 16.6044 21.6759 16.1162L17.8098 12.2501L19.7294 10.3305C20.3728 9.687 20.1351 8.59358 19.2825 8.27546L4.28743 2.68029Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCursor3;
